import { StateCreator } from 'zustand';
import { UserPreferences, DimensionUnit, WeightUnit, FreightMode, ThemeMode } from '@freight-cbm/shared-types';

export interface PreferencesSlice {
  preferences: UserPreferences;
  setPreference: <K extends keyof UserPreferences>(key: K, value: UserPreferences[K]) => void;

}

const defaultPreferences: UserPreferences = {
  defaultDimUnit: DimensionUnit.Cm,
  defaultWeightUnit: WeightUnit.Kg,
  defaultFreightMode: FreightMode.Air,
  defaultDimDivisor: 0,
  theme: ThemeMode.System,
  currency: 'USD',
  defaultRatePerKg: 0,
  defaultRatePerCBM: 0,
  showDemoOption: true,
};

export const createPreferencesSlice: StateCreator<PreferencesSlice> = (set) => ({
  preferences: { ...defaultPreferences },
  setPreference: (key, value) =>
    set((state) => ({
      preferences: { ...state.preferences, [key]: value },
    })),
});
